// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.

/**
 * Sprint 41.5.0 G4.5 — Deprecated governance route redirect.
 *
 * After the G4 page deduplication audit the governance DpaReviewPage
 * and OnboardingPipelinePage were deleted; their lifecycles were
 * ported in as panels on vendor-risk/VendorOnboardingCasePage. The
 * old bookmarkable paths are replaced by this component which fires a
 * one-time informational toast and Navigate()s to the canonical case
 * list page so the user can pick the relevant vendor case.
 */

import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useToast } from './Toast.js';
import { useLocale } from '../hooks/useLocale.js';
import { tKey } from '../utils/i18n-helpers.js';

interface DeprecatedGovernanceRedirectProps {
  to: string;
  /** Short identifier used for the toast message key (e.g. "dpa_reviews"). */
  redirectKey: string;
}

export function DeprecatedGovernanceRedirect({
  to,
  redirectKey,
}: DeprecatedGovernanceRedirectProps) {
  const toast = useToast();
  const { t } = useLocale();

  useEffect(() => {
    const gov = t.governance as unknown as Record<string, unknown>;
    const message = tKey(
      gov,
      `deprecated_redirect_${redirectKey}`,
      'This page moved to the Vendor Risk module.',
    );
    toast.info(message);
    // Fire the toast once per mount — no retriggers when props change.
  }, []);

  return <Navigate to={to} replace />;
}
